import React from 'react';

export const AmbientColor = () => {
  return (
    <div className="absolute inset-0 pointer-events-none -z-10 overflow-hidden">
      {/* Subtle discreet red ambient lighting glow matching /about */}
      <div
        className="absolute top-1/4 right-0 w-[550px] h-[550px] rounded-full blur-[160px] opacity-[0.04] bg-[#c02029]"
      />
      <div
        className="absolute top-3/4 left-0 w-[500px] h-[500px] rounded-full blur-[160px] opacity-[0.035] bg-[#c02029]"
      />
      {/* Soft lavender-indigo subtle ambient hue */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] rounded-full blur-[180px] opacity-[0.05] bg-[#301754]"
      />
    </div>
  );
};
